
import { Component, Prop, Mixins, Emit } from "vue-property-decorator"
import StatusMixin from "../mixins/status-mixin"
import ChangeStatusButton from "@/components/ChangeStatusButtons/ChangeStatusButton.vue"

@Component({
  components: { ChangeStatusButton },
})
export default class ChangeStatusButtons extends Mixins(StatusMixin) {
  @Prop()
  private role!: string

  @Prop()
  private status!: string

  @Prop()
  private statusName!: string

  @Emit("emitStatus")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private emitStatus(status: string) {
    /** */
  }

  @Emit("emitErrorMessages")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private emitErrorMessages(errorMessages: string[]) {
    /** */
  }

  //
  // Getters
  //
  get isDraft(): boolean {
    return this.status === "draft"
  }

  get isUnapproved(): boolean {
    return this.status === "unapproved"
  }

  get isPublish(): boolean {
    return this.status === "publish"
  }

  get isUnpublish(): boolean {
    return this.status === "unpublish"
  }

  get isEditor(): boolean {
    return this.role === "editor"
  }

  get isAdministrator(): boolean {
    return this.role === "administrator"
  }

  //
  // Methods
  //
  private updateStatus(status: string) {
    this.emitStatus(status)
  }

  private sendErrorMessages(messages: string[]) {
    this.emitErrorMessages(messages)
  }
}
